/*
 ** Generated from tools/cli/theme.template.js
 */
import lightTheme from "@bookingcom/bui-themes/traveller_ex/light";
import darkTheme from "@bookingcom/bui-themes/traveller_ex/dark";
import "@bookingcom/bui-themes/traveller_ex/variables.css";
const theme = {
    lightDefinition: lightTheme,
    darkDefinition: darkTheme,
    lightAttributes: { "data-bui-theme": "traveller_ex-light" },
    darkAttributes: { "data-bui-theme": "traveller_ex-dark" },
};
export default theme;
